//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/LineDesigner.js";
import "../no/Builder.js";
let d=[[[0,"Name",1,0],[0,"ParentName",1,0],[0,"ParentPartOccurance",1,"TaggedObject",0],[0,"WorkareaTypeName",1,0]],[[["displayName","internalName"],"SetInternalName",{},2,0],[["nWorkAreaType"],"GetWorkAreaTypeByParsingPaxFile",{R_:{workAreaType:""}},0,0],[["internalName","nAllowChildrenType"],"GetAllowChildTypeForParent",{R_:{childrenType:""}},1,0],[[],"GetDefaultName",{R_:{workareaDefaultName:''}},0,0]],[]];
SPLM.LineDesigner.AddWorkareaBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.LineDesigner.AddWorkareaBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;